<template>
  <q-form ref="form" class="full-width q-px-md">
    <div class="row">
      <div class="col-12">
        <q-tabs v-model="tab">
          <q-tab name="general" label="General" />
          <q-tab
            v-if="formData.id"
            name="playerLabels"
            label="Participant Labels"
          />
        </q-tabs>
      </div>
    </div>
    <div v-if="tab == 'general'" class="row">
      <div class="col-12">
        <h6 class="q-my-none q-mt-xs">General</h6>
      </div>
      <div class="col-12 col-md-6 q-pa-xs">
        <q-input
          v-model="formData.discipline_name"
          label="Discipline Name"
          v-bind="siteCFG.fields.general"
        >
        </q-input>
      </div>
      <div class="col-12 col-md-6 q-pa-xs">
        <q-select
          v-model="formData.type"
          label="Sport Type"
          v-bind="siteCFG.fields.general"
          :options="disciplineTypes"
          use-input
          input-debounce="0"
          new-value-mode="add"
        >
        </q-select>
      </div>
      <div class="col-12 col-md-6 q-pa-xs">
        <q-input
          v-model="formData.description"
          label="Description"
          v-bind="siteCFG.fields.general"
        >
        </q-input>
      </div>
      <div class="col-12 col-md-6 q-pa-xs">
        <q-input
          v-model="formData.numLanes"
          label="Num Lanes (Optional)"
          v-bind="siteCFG.fields.general"
        >
        </q-input>
      </div>
      <div class="col-12 col-md-6 q-pa-xs">
        <q-input
          v-model="formData.disciplineOmegaCode"
          label="Omega Stroke Code"
          v-bind="siteCFG.fields.general"
        >
        </q-input>
      </div>
      <div class="col-12 col-md-6 q-pa-xs">
        <q-input
          v-model="formData.relayCode"
          label="Relay Code"
          v-bind="siteCFG.fields.general"
        >
        </q-input>
      </div>
      <div class="col-12 q-pa-xs">
        <assignDiscipline
          :id="formData.parentDiscipline"
          @changed="val => (formData.parentDiscipline = val)"
        />
      </div>
      <div class="col-12 q-pa-xs">
        <q-checkbox
          v-model="formData.isTeamDiscipline"
          label="Team Discipline"
          dense
          @input="isTeamDiscipline"
          :true-value="1"
          :false-value="0"
          indeterminate-value="No-Value"
        ></q-checkbox>
        <br />
        <q-checkbox
          v-model="formData.isIndividualDiscipline"
          label="Individual Discipline"
          @input="isIndividualDiscipline"
          dense
          :true-value="1"
          :false-value="0"
          indeterminate-value="No-Value"
        ></q-checkbox>
        <br />
        <q-checkbox
          v-model="formData.reversedPlacings"
          label="Reversed Placings"
          dense
          :true-value="1"
          :false-value="0"
          indeterminate-value="No-Value"
        ></q-checkbox>
      </div>

      <!-- <div class="col-12 col-md-6 q-pa-xs">
        <q-input
          :disable="formData.isTeamDiscipline != 1"
          v-model="formData.teamSizeMin"
          label="Team Min Size"
          v-bind="siteCFG.fields.general"
          type="number"
        >
        </q-input>
      </div>
      <div class="col-12 col-md-6 q-pa-xs">
        <q-input
          :disable="formData.isTeamDiscipline != 1"
          v-model="formData.teamSizeMax"
          label="Team Max Size"
          v-bind="siteCFG.fields.general"
          type="number"
          @input="teamSizeChanged"
        >
        </q-input>
      </div>
      <div class="col-12 q-pa-xs">
        <q-input
          :disable="formData.isTeamDiscipline != 1"
          v-model="formData.maxReserves"
          label="Max Reserves"
          v-bind="siteCFG.fields.general"
          type="number"
          @input="teamSizeChanged"
        >
        </q-input>
      </div> -->
    </div>
    <div class="row" v-if="tab == 'playerLabels'">
      <div class="col-12">
        <h6 class="q-my-none q-mt-xs">
          Participant Labels
          <q-btn
            class="q-ml-md"
            color="positive"
            text-color="white"
            no-caps
            @click="addParticipant"
          >
            <q-icon
              name="mdi-plus-circle"
              color="white"
              class="q-mr-sm"
              size="xs"
            ></q-icon>
            Add Player
          </q-btn>
        </h6>
      </div>
      <div class="col-12">
        <div class="row text-center" style="font-size: 10pt; font-weight: bold">
          <div class="col-3">Label</div>
          <div class="col-1">200m<br />Badge</div>
          <div class="col-1">PS or<br />SLG</div>
          <div class="col-1">SLG<br />Award</div>
          <div class="col-1">IRB<br />Crew</div>
          <div class="col-1">IRB<br />Driver</div>
          <div class="col-1">Mixed<br />Gender</div>
          <div class="col-1">Open<br />Age</div>
          <div class="col-1">Required</div>
          <div class="col-1"></div>
        </div>
      </div>
      <div
        v-for="(label, n) in formData.playerLabels"
        :key="`playerlabel_${n}`"
        class="col-12"
      >
        <div class="row" v-if="label.type == 'Player'">
          <div class="col-3">
            <q-input :label="`Player ${n + 1}`" v-model="label.name"> </q-input>
          </div>
          <div class="col-1">
            <q-checkbox
              v-model="label.twoHundredMeter"
              dense
              :false-value="0"
              :true-value="1"
              indeterminate-value="no-value"
              class="q-pa-md"
            ></q-checkbox>
          </div>
          <div class="col-1">
            <q-checkbox
              v-model="label.patrolSupport"
              :false-value="0"
              :true-value="1"
              indeterminate-value="no-value"
              dense
              class="q-pa-md"
            ></q-checkbox>
          </div>
          <div class="col-1">
            <q-checkbox
              v-model="label.slg"
              :false-value="0"
              :true-value="1"
              indeterminate-value="no-value"
              dense
              class="q-pa-md"
            ></q-checkbox>
          </div>
          <div class="col-1">
            <q-checkbox
              v-model="label.crew"
              :false-value="0"
              :true-value="1"
              indeterminate-value="no-value"
              dense
              class="q-pa-md"
            ></q-checkbox>
          </div>
          <div class="col-1">
            <q-checkbox
              v-model="label.driver"
              dense
              :false-value="0"
              :true-value="1"
              indeterminate-value="no-value"
              class="q-pa-md"
            ></q-checkbox>
          </div>

          <div class="col-1">
            <q-checkbox
              v-model="label.mixed"
              dense
              :false-value="0"
              :true-value="1"
              indeterminate-value="no-value"
              class="q-pa-md"
            ></q-checkbox>
          </div>
          <div class="col-1">
            <q-checkbox
              v-model="label.noMaxAge"
              dense
              :false-value="0"
              :true-value="1"
              indeterminate-value="no-value"
              class="q-pa-md"
            ></q-checkbox>
          </div>
          <div class="col-1">
            <q-checkbox
              v-model="label.required"
              dense
              :false-value="0"
              :true-value="1"
              indeterminate-value="no-value"
              class="q-pa-md"
            ></q-checkbox>
          </div>
          <div class="col-1">
            <q-btn
              icon="mdi-close"
              color="negative"
              flat
              @click="removeParticipant(label.index)"
            ></q-btn>
          </div>
        </div>
      </div>
      <hr style="background: black" class="full-width q-mt-md" />
      <div class="col-12 q-mt-none">
        <h6 class="q-my-none q-mt-xs">
          Reserve Labels
          <q-btn
            class="q-ml-md"
            color="positive"
            text-color="white"
            no-caps
            unelevated
            @click="addReserve"
          >
            <q-icon
              name="mdi-plus-circle"
              color="white"
              class="q-mr-sm"
              size="xs"
            ></q-icon>
            Add Reserve
          </q-btn>
        </h6>
      </div>
      <div
        v-for="(label, n) in formData.playerLabels"
        :key="`reservelabel_${n}`"
        class="col-12"
      >
        <div class="row" v-if="label.type == 'Reserve'">
          <div class="col-3">
            <q-input :label="`Reserve ${n + 1}`" v-model="label.name">
            </q-input>
          </div>
          <div class="col-1">
            <q-checkbox
              v-model="label.twoHundredMeter"
              dense
              :false-value="0"
              :true-value="1"
              indeterminate-value="no-value"
              class="q-pa-md"
            ></q-checkbox>
          </div>
          <div class="col-1">
            <q-checkbox
              v-model="label.patrolSupport"
              :false-value="0"
              :true-value="1"
              indeterminate-value="no-value"
              dense
              class="q-pa-md"
            ></q-checkbox>
          </div>
          <div class="col-1">
            <q-checkbox
              v-model="label.slg"
              :false-value="0"
              :true-value="1"
              indeterminate-value="no-value"
              dense
              class="q-pa-md"
            ></q-checkbox>
          </div>
          <div class="col-1">
            <q-checkbox
              v-model="label.crew"
              :false-value="0"
              :true-value="1"
              indeterminate-value="no-value"
              dense
              class="q-pa-md"
            ></q-checkbox>
          </div>
          <div class="col-1">
            <q-checkbox
              v-model="label.driver"
              dense
              :false-value="0"
              :true-value="1"
              indeterminate-value="no-value"
              class="q-pa-md"
            ></q-checkbox>
          </div>

          <div class="col-1">
            <q-checkbox
              v-model="label.mixed"
              dense
              :false-value="0"
              :true-value="1"
              indeterminate-value="no-value"
              class="q-pa-md"
            ></q-checkbox>
          </div>
          <div class="col-1">
            <q-checkbox
              v-model="label.noMaxAge"
              dense
              :false-value="0"
              :true-value="1"
              indeterminate-value="no-value"
              class="q-pa-md"
            ></q-checkbox>
          </div>
          <div class="col-1">
            <q-checkbox
              v-model="label.required"
              dense
              :false-value="0"
              :true-value="1"
              indeterminate-value="no-value"
              class="q-pa-md"
            ></q-checkbox>
          </div>
          <div class="col-1">
            <q-btn
              icon="mdi-close"
              color="negative"
              flat
              @click="removeParticipant(label.index)"
            ></q-btn>
          </div>
        </div>
      </div>
    </div>
  </q-form>
</template>

<script>
import { mapGetters } from "vuex";
import assignDiscipline from "@/components/disciplines/assignDiscipline.vue";

export default {
  components: { assignDiscipline },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
      siteCFG: "settings/siteCFG",
      data: "disciplines/current",
      dataLoading: "disciplines/currentLoading",
      disciplineTypes: "settings/disciplineTypes",
      disciplineTypesLoading: "settings/disciplineTypesLoading",
      disciplineSports: "settings/disciplineSports"
    })
  },
  props: {
    id: {
      default: null
    }
  },
  watch: {
    id: function() {
      this.init();
    },
    data: function() {
      this.init();
    }
  },
  data: () => ({
    // Extra Data
    formData: {
      isTeamDiscipline: 0,
      isIndividualDiscipline: 1,
      teamSizeMin: 1,
      teamSizeMax: 1,
      playerLabels: [],
      parentDiscipline: null
    },
    tab: "general"
  }),
  beforeCreate() {},
  mounted() {
    this.init();
    this.$store.dispatch("disciplines/loadByID", this.id);
    this.$store.dispatch("settings/loadDisciplineTypes");
  },
  methods: {
    init() {
      if (this.data != null && this.data.id == this.id) {
        this.formData = JSON.parse(JSON.stringify(this.data));
        this.formData.playerLabels = JSON.parse(this.formData.playerLabels);
      } else {
        this.formData = {
          isTeamDiscipline: 0,
          isIndividualDiscipline: 1,
          teamSizeMin: 1,
          teamSizeMax: 1,
          playerLabels: [],
          parentDiscipline: null
        };
      }
    },
    create() {
      // Check for duplicate playerLabels
      // let playerLabels = this.formData.playerLabels;
      // let playerLabelNames = playerLabels.map(pl => pl.name);
      // let uniquePlayerLabelNames = [...new Set(playerLabelNames)];
      // if (playerLabelNames.length != uniquePlayerLabelNames.length) {
      //   this.$emit("loadingStateChanged", false);
      //   this.$q.notify({
      //     position: "top-right",
      //     type: "negative",
      //     message: "Duplicate Player Labels"
      //   });
      //   return;
      // }

      this.$emit("loadingStateChanged", true);

      this.$refs.form.validate().then(result => {
        let payload = JSON.parse(JSON.stringify(this.formData));
        // payload.playerLabels = JSON.stringify(payload.playerLabels);
        if (result) {
          this.$store.dispatch("disciplines/new", payload).then(result => {
            this.$emit("loadingStateChanged", false);
            if (result.Result == "Success") {
              this.$emit("close", true);
              this.formData = {};
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: result.Response.Message
              });
            }
          });
        } else {
          this.$emit("loadingStateChanged", false);
        }
      });
    },
    save() {
      let playerLabels = this.formData.playerLabels;
      let playerLabelNames = playerLabels.map(pl => pl.name);
      let uniquePlayerLabelNames = [...new Set(playerLabelNames)];
      if (playerLabelNames.length != uniquePlayerLabelNames.length) {
        this.$emit("loadingStateChanged", false);
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "Duplicate Player Labels"
        });
        return;
      }
      this.$emit("loadingStateChanged", true);
      let payload = JSON.parse(JSON.stringify(this.formData));
      payload.playerLabels = JSON.stringify(payload.playerLabels);

      this.$store.dispatch("disciplines/save", payload).then(result => {
        this.$emit("loadingStateChanged", false);
        if (result.Result == "Success") {
          this.$emit("close", true);
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message
          });
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later"
          });
        }
      });
    },
    isIndividualDiscipline() {
      this.formData.isTeamDiscipline =
        this.formData.isIndividualDiscipline == 0 ? 1 : 0;
      this.formData.teamSizeMin = 1;
      this.formData.teamSizeMax = 1;
    },
    isTeamDiscipline() {
      this.formData.isIndividualDiscipline =
        this.formData.isTeamDiscipline == 0 ? 1 : 0;
    },
    addParticipant() {
      this.formData.playerLabels.push({
        name: "",
        index: this.formData.playerLabels.length,
        type: "Player",
        twoHundredMeter: 0,
        slg: 0,
        crew: 0,
        driver: 0,
        mixed: 0,
        noMaxAge: 0,
        patrolSupport: 0,
        required: 0
      });
    },
    addReserve() {
      this.formData.playerLabels.push({
        name: "",
        index: this.formData.playerLabels.length,
        type: "Reserve",
        twoHundredMeter: 0,
        slg: 0,
        crew: 0,
        driver: 0,
        mixed: 0,
        noMaxAge: 0,
        patrolSupport: 0,
        required: 0
      });
    },
    removeParticipant(index) {
      this.formData.playerLabels = this.formData.playerLabels.filter(
        pl => pl.index != index
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.formSubTitle {
  font-weight: bold;
}
</style>
